<template>
  <div class="app-voucher-top-up-wrapper">
    <voucher-input :placeholder="placeholder" :next-step="'modal'" ref="VoucherInput">
      <template v-for="slot in possibleChildSlotsFor('VoucherInput')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </voucher-input>
    <CustomModal
      :visible="showAppProcessConfirmModal"
      :slotData="slotData"
      :showPrev="true"
      :showNext="true"
      @close="setVoucherView(inputStepName)"
      @prev="setVoucherView(inputStepName)"
      @next="confirm"
    >
      <template slot="header">
        <slot name="header">
          <slot name="txtModalTitleVoucherConfirm"></slot>
        </slot>
      </template>
      <p>
        <slot name="txtModalBodyVoucherConfirm"></slot>
        {{ slotData.voucherCode }}.
      </p>
    </CustomModal>
  </div>
</template>
<script>
import VoucherInput, { stepName as inputStepName } from '@/components-v2/flows/LIDL/TopUp/Voucher/Input.vue'
import CustomModal from '@/components/generic/CustomModal.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'VoucherTopUpWrapper',
  import: {
    inputStepName
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  components: {
    VoucherInput,
    CustomModal
  },
  computed: {
    ...mapGetters('topUp', ['view', 'voucherCode']),
    showAppProcessConfirmModal() {
      return this.view === 'modal'
    },
    slotData() {
      return {
        voucherCode: this.voucherCode
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    confirm() {
      this.loading = true
      this.confirmVoucher({ nextStep: inputStepName }).then(
        () => {
          this.loading = false
          // after success clear the input field
          this.$refs.VoucherInput.reset()
        },
        () => {
          this.loading = false
        }
      )
    },
    ...mapActions('topUp', ['confirmVoucher']),
    ...mapMutations('topUp', ['setVoucherView'])
  },
  mixins: [slotProxy()]
}
</script>
